import dispatcher, { dispatch } from '../dispatcher/Dispatcher';

import ajax, { ajaxDispatch } from '../common/utils/ajax';

export default {
	//
	//测试未使用
    getEmpRciList(data){
        ajaxDispatch({
			action: 'get-emp-rci-list',
			url: '/ess-rci-list',
			method: 'get',
			data: data
		});
    },
	//
	//ess获取补打卡的异常数据
	getEmpRciExList(period){
		//[{"att_exe_perid":"1126","att_exe_empid":"64656","att_exe_date":"2017-07-18 00:00:00.0","att_exe_typid":"1000","att_exe_typname":"常日班","att_exe_resid":"4","att_exe_resdesc":"未打卡","att_exe_ctime":"2017-07-18 08:30:00.0","att_exe_gtime":"2017-07-18 17:00:00.0","att_exe_actime":null,"att_exe_agtime":null,"att_exe_lv":null,"att_exe_le":null,"comp_lvcode":"10001000"}]
		if(period == 0)
			period = '';
		//console.log('/ess-exce-timeclock?period='+period);
		ajax.get('/ess-exce-timeclock?period='+period)
			.then((res) => {
				//console.log(res);
				dispatch({
					type: 'get-emp-rci-exlist',
					data: res
				});
			})
			.catch((res) => {
				console.log(res);
				dispatch({
					type: 'get-emp-rci-exlist',
					data: []
				});
			});
	},
	//
	//ess获取补打卡的异常单条数据信息
	getEmpRciExDetail(id){
		console.log('/ess-att-exception-get?id='+id);
		ajax.get('/ess-att-exception-get?id='+ id)
			.then((res) => {
				console.log(res);
				dispatch({
					type: 'get-emp-rci-exlist-detail',
					data: res
				});
			})
			.catch((res) => {
				console.log(res);
			});
	},
	//获取异常数据的区间列表
	getEmpRciPeriodList(){
		//[{"pla_per_id":"1117","pla_per_code":"201610"},{"pla_per_id":"1117","pla_per_code":"201610"}]
		//console.log('/get-period-list');
		ajax.get('/get-period-list')
			.then((res) => {
				//console.log(JSON.stringify(res));
				res.map((item, index) => {
					let year = item.pla_per_code.substring(0,4);
					item.pla_per_code = item.pla_per_code.replace(year,'');
					item.pla_per_code = year + '-'+ item.pla_per_code;
				});
				dispatch({
					type: 'get-emp-rci-period-list',
					data: res
				});
			})
			.catch((res) => {
				console.log(res);
			});
	},
	//核算数据根据周期ID
	checkRciExList(pid){
		//console.log('/ess-calc-exce-timeclock?period='+pid);
		ajax.get('/ess-calc-exce-timeclock?period='+pid)
			.then((res) => {
				if(res.res == true){
					alert('success');
					dispatch({
						type: 'check-rci-ex-list-success',
						data: pid
					});
				}else{
					alert(res.error);
				}
			})
			.catch((res) => {
				console.log(res);
			});
	},
	//获取补打卡的表单
	getRciApplyForm(){
		dispatch({
			type: 'get-rci-form'
		});
		ajax.get('/ess-repair-timeclock-form')
			.then((form) => {
				//console.log(form);
				ajax.getScript(form.JS_CONFIG_FILE)
					.then(() => {
						dispatch({
							type: 'get-rci-form-success',
							data: form
						});
					});
			});
	},
	/**
	 * Get edit info
	 * @param id
	 */
	getRciEditApplyForm(id) {
		dispatch({
			type: 'get-rci-form'
		});

		ajax.get('/ess-repair-timeclock-get', {
			id
		})
			.then((res) => {
				//console.log(res);
				dispatch({
					type: 'get-rci-form-success',
					data: res
				});
			});
	},
	//
	//ess补打卡提交申请
	empRciApplyInsert(formData, url){
		// dispatch({
		// 	type: 'insert-rci-form'
		// });
		//console.log(url);
		// ajax.post(url, formData)
		// 	.then((res) => {
		// 		//console.log(JSON.stringify(res));
		// 		console.log(res);
		// 		// dispatch({
		// 		// 	type: 'get-emp-rci-period-list',
		// 		// 	data: res
		// 		// });
		// 	})
		// 	.catch((res) => {
		// 		console.log(res);
		// 	});

		ajaxDispatch({
			action: 'insert-rci-form',
			url: url,
			method: 'post',
			data: formData
		})
			.catch(e => {
				console.log(e);
			});
	},
	//
	//ess补打卡申请列表
	empRciApplyList(data){
		ajaxDispatch({
			action: 'get-emp-rci-list',
			url: '/ess-repair-timeclock-list',
			method: 'get',
			data: data
		});
	},
	//获取单条补打卡信息
	empRciApplyGet(id){
		ajaxDispatch({
			action: 'get-emp-rci-record',
			url: '/ess-repair-timeclock-get',
			method: 'get',
			data: {
				id
			}
		});
	},
	//获取单条补打卡的信息，字段名+值
	empRciApplyRecord(id) {
		ajaxDispatch({
			action: 'get-emp-rci-record',
			url: '/ess-tc-detail',
			method: 'get',
			data: {
				id
			}
		});
	},
	//mss获取未审批的申请列表
	mssRciPendingRecords(query) {
		//console.log('/mss-timeclock-todolist');
		ajaxDispatch({
			action: 'get-rci-pending-records',
			url: '/mss-timeclock-todolist',
			method: 'get',
			data: query
		});
	},
	//
	//MSS补打卡申请单审核【通过、拒绝】
	mssApproveRecord(data){
		console.log(data);
		ajaxDispatch({
			action: 'approve-rci-pending-record',
			url: '/mss-tc-approve',
			method: 'post',
			data
		});
	},
	getFilter(companyCode) {
		ajax.get('/custom/config/' + companyCode + '_LV_STATE.json')
			.then((res) => {
				dispatch({
					type: 'get-rci-filter-success',
					data: (res && res.items)
				});
			});
	}
};


// WEBPACK FOOTER //
// ./src/data-utils/RepairClockInDataUtils.js